import React from "react";
import HeroBlock from "./blocks/HeroBlock";
import FeaturesBlock from "./blocks/FeaturesBlock";
import SectionBlock from "./blocks/SectionBlock";
import ImageWithTextBlock from "./blocks/ImageWithTextBlock";
import ListBlock from "./blocks/ListBlock";
import CardsBlock from "./blocks/CardsBlock";
import CTABlock from "./blocks/CTABlock";
import FAQBlock from "./blocks/FAQBlock";
import GalleryBlock from "./blocks/GalleryBlock";
import ContactFormBlock from "./blocks/ContactFormBlock";

export default function BlockRenderer({ block }) {
  switch (block.type) {
    case "hero":
      return <HeroBlock data={block} />;

    case "features":
      return <FeaturesBlock data={block} />;

    case "section":
      return <SectionBlock data={block} />;

    case "imageWithText":
      return <ImageWithTextBlock data={block} />;

    case "list":
      return <ListBlock data={block} />;

    case "cards":
      return <CardsBlock data={block} />;

    case "cta":
      return <CTABlock data={block} />;

    case "faq":
      return <FAQBlock data={block} />;

    case "imageGallery":
      return <GalleryBlock data={block} />;

    case "contactForm":
      return <ContactFormBlock data={block} />;

    default:
      return <div>Unknown Block Type</div>;
  }
}
